export const NavChildren = {
  bindings: {
    items: '<',
  },

  template: `
    <nav class="navbar navbar--children bg-teal-dark p-0">
      <div class="container">
        <ul class="navbar-nav navbar-nav--list w-100 flex-row justify-content-around justify-content-md-start">
          <li class="nav-item mt-1 mr-md-3"
            ng-repeat="item in $ctrl.items track by $index">
            <nav-item
              title="item.title"
              icon="item.icon"
              path="item.path">
            </nav-item>
          </li>
        </ul>
      </div>
    </nav>`,
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavChildren.js